import axios from 'axios';
import { getToken, createApiUrl } from '../../util';
import { DESIGN_MODES, ROOF_DESIGN_MODES } from '../../constants';
import api from 'api/axiosInstance';
import { FacetEditShadingStatus, normalizeFacetShadingStatus } from 'api/editDsm';

// Resolves to the reshade the switch made necessary (if any) — the switch re-lays the
// shared panel key into the target mode's dpd, like POST /add-panel-layout.
export async function switchDesignMode(input: { mode: string, uuid: string, panelKey?: string }): Promise<FacetEditShadingStatus | undefined> {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const apiUrl = '/designs/switch-design-mode/';
	const { data } = await api.patch(createApiUrl(apiUrl), input, config);
	return normalizeFacetShadingStatus(data);
}

export async function switchRoofDesignMode(input: { roofMode: ROOF_DESIGN_MODES, solarMode: DESIGN_MODES, uuid: string }) {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const apiUrl = '/designs/roof/switch-design-mode/';
	const { data } = await api.patch(createApiUrl(apiUrl), input, config);
	return true;
}